import axios from 'axios';
import API from '../config/API';

function sendToClient(params) {
    // The v2 auth middleware reads the custom 'accessToken' header
    // (req.get('accessToken')) — NOT the Authorization bearer.
    const headers = {
        'Content-Type': 'application/json',
        'accessToken': localStorage.getItem('accessToken') || '',
    };
    return axios.post(API.MAGIC_LINK_SEND, params, { headers });
}

function consumeToken(token) {
    return axios.post(API.MAGIC_LINK_CONSUME, { token }, {
        headers: { 'Content-Type': 'application/json' }
    });
}

export const magicLinkService = {
    sendToClient,
    consumeToken
};
